import React from 'react';
import Button from '@material-ui/core/Button';

const WelcomeLandingPage = (props) => {

  return (
    <div style={{ width: '70vw', height: '80vh', backgroundColor: "#fafafa"}}>
        <div style={{textAlign: 'center'}}><img src="https://lp-custom-data.s3.us-west-2.amazonaws.com/quickLogo.png" /></div>
        <div style={{minWidth: '300px'}}>
            <div style={{textAlign: 'center', marginTop: '50px', marginBottom: '50px'}}>
            <h3 style={{fontWeight: '600'}}>Welcome to the PhishCloud Portal!</h3>
            <h4 style={{fontWeight: '600'}}>We are preparing your experience.</h4>
            </div>


    </div>
    <div style={{height: '20rem', display: 'flex', justifyContent: 'center', alignItems: 'flex-end'}}>
    <Button style={{float: 'right',}}  onClick={() => props.setWelcomePage(false)} variant='contained' color="primary">Login to PhishCloud</Button>
    </div>
    </div>
        
  );
};
export default WelcomeLandingPage;